import Layout from '@/layout'

const route = {
  path: '/novelReporthing',
  component: Layout,
  alwaysShow: true, // will always show the root menu
  name: 'NovelReporthing',
  meta: {
    title: '小说小程序报表',
    icon: 'miniProgram',
    roles: [
      'novel_mini_release'
    ]
  },
  children: [
    // 图表分析
    {
      path: '/novelReporthing/releaseGroupList/index',
      component: () => import('@/views/novelReporthing/releaseGroupList/index.vue'),
      name: 'releaseGroupList',
      meta: {
        title: '投放组',
        icon: 'component',
        roles: [
          'novel_mini_release_group'
        ]
      }
    },
    {
      path: '/novelReporthing/bookOwnership/index',
      component: () => import('@/views/novelReporthing/bookOwnership/index.vue'),
      name: 'bookOwnership',
      meta: {
        title: '书籍归属',
        icon: 'component',
        roles: [
          'novel_mini_release_belong'
        ]
      }
    },
    {
      path: '/novelReporthing/dropLocationList/index',
      component: () => import('@/views/novelReporthing/dropLocationList/index.vue'),
      name: 'dropLocationList',
      meta: {
        title: '投放位置',
        icon: 'component',
        roles: [
          'novel_mini_release_positions'
        ]
      }
    },
    {
      path: '/novelReporthing/bindingRelationList/index',
      component: () => import('@/views/novelReporthing/bindingRelationList/index.vue'),
      name: 'bindingRelationList',
      meta: {
        title: '绑定关系',
        icon: 'component',
        roles: [
          'novel_mini_release_bind'
        ]
      }
    }, {
      path: '/novelReporthing/reportList/index',
      component: () => import('@/views/novelReporthing/reportList/index.vue'),
      name: 'reportList',
      meta: {
        title: '报表数据',
        icon: 'component',
        roles: [
          'novel_mini_release_report'
        ]
      }
    }, {
      path: '/novelReporthing/totalReportList/index',
      component: () => import('@/views/novelReporthing/totalReportList/index.vue'),
      name: 'totalReportList',
      meta: {
        title: '总计报表',
        icon: 'component',
        roles: [
          'novel_mini_release_total_report'
        ]
      }
    }, {
      path: '/novelReporthing/reportForm/index',
      component: () => import('@/views/novelReporthing/reportForm/index.vue'),
      name: 'reportForm',
      meta: {
        title: 'T图列表',
        icon: 'component',
        roles: [
          'novel_mini_release_t_report'
        ]
      }
    },
    {
      path: '/novelReporthing/bindingRelationListSite/index',
      component: () => import('@/views/novelReporthing/bindingRelationListSite/index.vue'),
      name: 'bindingRelationListSite',
      meta: {
        title: '绑定关系(站点)',
        icon: 'component',
        roles: [
          'novel_mini_site_release_bind'
        ]
      }
    }, {
      path: '/novelReporthing/reportListSite/index',
      component: () => import('@/views/novelReporthing/reportListSite/index.vue'),
      name: 'reportListSite',
      meta: {
        title: '报表数据(站点)',
        icon: 'component',
        roles: [
          'novel_mini_site_release_report'
        ]
      }
    }, {
      path: '/novelReporthing/totalReportListSite/index',
      component: () => import('@/views/novelReporthing/totalReportListSite/index.vue'),
      name: 'totalReportListSite',
      meta: {
        title: '总计报表(站点)',
        icon: 'component',
        roles: [
          'novel_mini_site_release_total_report'
        ]
      }
    }, {
      path: '/novelReporthing/reportFormSite/index',
      component: () => import('@/views/novelReporthing/reportFormSite/index.vue'),
      name: 'reportFormSite',
      meta: {
        title: 'T图列表(站点)',
        icon: 'component',
        roles: [
          'novel_mini_site_release_t_report'
        ]
      }
    }
  ]
}

export default route
